import React from 'react';

export interface MemberInfo {
  id: string | null;
}
const defaultMemberInfo: MemberInfo = { id: null };
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const MemberContext = (React as any).createContext(defaultMemberInfo);



// WEBPACK FOOTER //
// ./app/gamma/src/modules/context.ts